<template lang="pug">
.terms
  .terms__container.inner-1080
    h2.terms__title {{ $t('pages.ssr_pricing_plans.terms.title') }}
    .terms__items
      .terms__single
        RocketIconSvg.terms__single-icon
        span.terms__single-name {{ $t('pages.ssr_pricing_plans.terms.1.title') }}
        p.terms__single-text {{ $t('pages.ssr_pricing_plans.terms.1.text') }}
      .terms__single
        ContractIconSvg.terms__single-icon
        span.terms__single-name {{ $t('pages.ssr_pricing_plans.terms.2.title') }}
        p.terms__single-text {{ $t('pages.ssr_pricing_plans.terms.2.text') }}
      .terms__single
        MoneyIconSvg.terms__single-icon
        span.terms__single-name {{ $t('pages.ssr_pricing_plans.terms.3.title') }}
        p.terms__single-text {{ $t('pages.ssr_pricing_plans.terms.3.text') }}
</template>

<script>
import RocketIconSvg from './svg/RocketIcon'
import ContractIconSvg from './svg/ContractIcon'
import MoneyIconSvg from './svg/MoneyIcon'

export default {
  components: {
    RocketIconSvg,
    ContractIconSvg,
    MoneyIconSvg
  }
}
</script>

<style lang="scss" scoped>
.terms {
  margin-bottom: $gap * 5;

  @include display-less(tablet) {
    margin-bottom: 46px;
  }

  &__title {
    color: #fff;
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 40px;

    @include display-less(tablet) {
      width: 100%;
      text-align: center;
    }
  }

  &__items {
    display: grid;
    grid-gap: $gap * 1.5;
    grid-template-columns: 1fr 1fr 1fr;

    @include display-less(tablet) {
      grid-template-columns: 1fr;
    }
  }

  &__single {
    display: flex;
    border-radius: 4px;
    padding: $gap * 1.5;
    flex-direction: column;
    background-color: #2E1F42;

    &-icon {
      margin-bottom: $gap;
    }

    &-name {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }

    &-text {
      color: #fff;
      font-size: 16px;
    }
  }
}
</style>
